import TYPES from '@/modules/shared/types';

// Domain
import { CustomerExtraBankAccountRepository }
  from '../../domain/repositories/customer-extra-bank-account-repository';
import { CustomerExtraBankAccountDto }
  from '../../domain/dtos/customer-extra-bank-account-dto';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class CustomerExtraBankAccountHttpRepository
implements CustomerExtraBankAccountRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/customer-extra-bank-account/`;

  create(extra_bank_account_dto: CustomerExtraBankAccountDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', extra_bank_account_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
